
export default function (file) {
  return () => import('@/view/' + file + '.vue')
} ;



// WEBPACK FOOTER //
// ./src/router/_import_development.js